 <div class="container-center">
  
  <div class="logo-container">
    <img src="assets/logo_tipay.svg" alt="Logo" class="logo" />
  </div>

  <h2 class="text-center mb-4 title">Se connecter</h2>

  <form [formGroup]="signinForm" (ngSubmit)="login()"> 
    <p-toast />

    <div class="form-group mt-4">
      <label>Adresse email *</label>
      <input type="email" class="form-control input" formControlName="email"  placeholder="Email"  required/>
        
    </div>

    <div class="form-group mt-4">
      <label>Mot de passe *</label>
      <input type="password" class="form-control input" formControlName="password" placeholder="Mot de passe" required />
    </div>

    <div class="text-end mb-2">
      <a class="a">Mot de passe oublié ?</a>
    </div>

    <button
      type="submit"
      class="btn-submit"
      [disabled]="!signinForm.valid"
    >
      Se connecter
    </button>
  </form>

</div>

  
   
